import {Event} from 'main.core';
import {BuyBlock} from 'asteq.catalog.buyblock';

export class Product extends Event.EventEmitter {
    constructor(params = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.Product');

        this.productId = params.productId;
        this.sliderId = params.sliderId;
        this.offers = params.offers;

        this.selectedOfferId = params.selectedOfferId;
        this.addUrlTemplate = params.addUrlTemplate;
        this.fastViewUrl = params.fastViewUrl;
        this.fastViewModalId = params.fastViewModalId;
        this.propsManager = null;
        this.buyBlock = null;
        this.hasUrlManagement = params.hasUrlManagement ?? false;

        this.initPropertiesManager(params);
        this.initBuyBlock(params);
        this.initPriceBlock(params);

        const initImages = this.offers[this.selectedOfferId]?.morePhoto;
        if (initImages) {
            BX.Event.EventEmitter.emit('BX.Asteq.Slider-'
                + this.sliderId
                + ':setImagesSets',
                {
                    images: {
                        thumbs: initImages.THUMB,
                        slides: initImages.SLIDE,
                        details: initImages.ORIGINAL,
                    },
                });
        }
    }

    initPropertiesManager(params) {
        if (!params.propsManagerId) {
            return;
        }

        this.propsManager = BX.Asteq.Catalog.SkuPropertiesManager
            .getInstance(params.propsManagerId);

        if (!this.propsManager) {
            return;
        }

        this.propsManager.subscribe('valueChange', this.onPropertiesValueChange.bind(this));
        this.subscribe('updatePropertiesValue', this.propsManager.onUpdatePropertiesValue.bind(this.propsManager));
    }

    initBuyBlock(params) {
        if (!params.buyBlockId) {
            return;
        }

        this.buyBlock = new BuyBlock({
            componentId: params.buyBlockId,
            currentOffer: this.offers[this.selectedOfferId],
            product: this,
        });
        this.subscribe('offerChange', this.buyBlock.onOfferChange.bind(this.buyBlock));
        this.buyBlock.subscribe('fastViewClick', this.onFastViewClick.bind(this));
    }

    initPriceBlock(params) {
        if (!params.priceBlockId) {
            return;
        }

        this.priceBlock = new BuyBlock({
            componentId: params.priceBlockId,
            product: this,
        });
        this.subscribe('offerChange', this.priceBlock.onOfferChange.bind(this.priceBlock));
    }

    filterOffersByProperties(offers, propsFilter) {
        const propsFilterKeys = Object.keys(propsFilter);
        return offers.filter((offer) =>
            propsFilterKeys.every((propId) =>
                offer.tree[propId] == propsFilter[propId])
        );
    }

    findMoreSimilarOfferByProperties(offers, propsSearch) {
        if (!offers) {
            return null;
        }

        if (offers.length == 1
            || !propsSearch
            || !propsSearch.length) {
            return offers[0];
        }

        const score = offers
            .map((offer, index) => ({
                index: index,
                value: propsSearch
                    .map((prop) =>
                        offer.tree[prop.propId] == prop.valueId ? 1 : 0)
                    .reduce((sumPart, scoreValue) => sumPart + scoreValue, 0),
            }))
            .sort((a, b) => b.value - a.value);

        return offers[score[0].index];
    }

    getDisplayPropertiesValuesByOffer(offers, offer) {
        const result = {};
        let filteredOffers = offers;
        Object.keys(offer.tree).forEach((propId) => {
            result[propId] = Array.from(new Set(
                filteredOffers.map((o) => o.tree[propId])));

            filteredOffers = this.filterOffersByProperties(filteredOffers, {
                [propId]: offer.tree[propId],
            });
        });
        return result;
    }

    delete() {
        // TODO: now for remove propery manager from static instances
        if (this.propsManager) {
            BX.Asteq.Catalog.SkuPropertiesManager
                .removeInstance(this.propsManager);
        }
    }

    onPropertiesValueChange(e) {
        const eventData = e.getData();
        const selectedValues = eventData.selectedValues;
        const changedPropertyId = eventData.change.property.getId();
        const changedPropertyIndex = selectedValues.findIndex((prop) => prop.propId == changedPropertyId);

        const propsFilter = {};
        selectedValues.slice(0, changedPropertyIndex + 1)
            .forEach((prop) => propsFilter[prop.propId] = prop.valueId);

        const propsSearch = selectedValues
            .slice(changedPropertyIndex + 1)
            .map((prop) => ({
                propId: prop.propId,
                valueId: prop.valueId
            }));

        const fullOffersList = Object.keys(this.offers).map((key) => this.offers[key]);
        const filteredoffersList = this.filterOffersByProperties(fullOffersList, propsFilter);
        const newOffer = this.findMoreSimilarOfferByProperties(filteredoffersList, propsSearch);

        if (!newOffer) {
            throw new Error('Не удалось найти подходящее торговое предложение');
        }

        const oldOffer = this.offers[this.selectedOfferId];
        this.selectedOfferId = newOffer.id;

        const displayPropsValues = this.getDisplayPropertiesValuesByOffer(fullOffersList, newOffer);

        this.emit('updatePropertiesValue', {
            displayPropsValues: displayPropsValues,
            selectedValues: newOffer.tree,
        });

        if (this.sliderId) {
            BX.Event.EventEmitter.emit('BX.Asteq.Slider-'
                + this.sliderId
                + ':setImages',
                {
                    images: {
                        thumbs: newOffer.morePhoto.THUMB,
                        slides: newOffer.morePhoto.SLIDE,
                        details: newOffer.morePhoto.ORIGINAL,
                    },
                });
        }

        if(this.hasUrlManagement && newOffer?.url) {

            window.history.replaceState({}, '', newOffer.url);
        }

        this.emit('offerChange', {
            newOffer: newOffer,
            oldOffer: oldOffer,
        });
    }


    onFastViewClick(e) {
        if (!this.fastViewUrl || !this.fastViewModalId) {
            return;
        }
        const modal = BX.Asteq.ModalAjax.getInstance(this.fastViewModalId);
        if (!modal) {
            return;
        }


        modal.show(this.fastViewUrl);
    }
}